// ─── api ────────────────────────────────────────────────────────────────────
// Requests for the Space Planning endpoints. They all go through the shared
// apiFetch helper, which adds the sign-in token and handles expired sign-ins.
// The server works out whose data this is from the token itself (see
// SpacePlanningController), so no phone number is ever sent from here.

import { apiFetch } from '../../../api/apiClient';

const sp = (path, options) => apiFetch(`/api/space-planning${path}`, options);

/**
 * The shared furniture-piece (stencil) catalog: the same handful of pieces
 * (bed, closet, workstation, door-swing arc, ...) for every customer.
 * Fetched once and reused for every layout.
 */
export function fetchFurniturePieces() {
  return sp('/furniture-pieces');
}

export function fetchCombinations() {
  return sp('/combinations');
}

export function updateNotes(combinationId, text) {
  return sp(`/combinations/${combinationId}/notes`, { method: 'PUT', body: { text } });
}

export function updateRank(combinationId, direction) {
  return sp(`/combinations/${combinationId}/rank`, { method: 'PUT', body: { direction } });
}

// roomLabel travels in the body, not in the address: room labels can contain
// a "/" (e.g. "Living / Dining"), which some servers reject inside an address.
export function updateSelection(combinationId, roomLabel, roomUseName, layoutOptionId) {
  return sp(`/combinations/${combinationId}/room-selection`, {
    method: 'PUT',
    body: { roomLabel, roomUseName, layoutOptionId },
  });
}
